import { Notification } from "@/interfaces/Notification"

export const weightToColorMap: Record<number, string> = {
    1: 'bg-blue-500',
    2: 'bg-green-500',
    3: 'bg-orange-500',
    4: 'bg-red-500',
} as const

export const notificationTypeWeight: Record<Notification['type'], number> = {
    info: 1,
    success: 2,
    warning: 3,
    error: 4,
} as const
